<template>
  <div v-if="isDefaultContentBlock" :style="myBlockProps.getStyles(visible)">
    <dynamic-block v-for="child in myChildren" :key="child.properties.guid" :block="child"/>
  </div>
  <paginable-content-block v-else-if="isPaginableContentBlock" v-bind="$props" />
  <scrollable-content-block v-else-if="isScrollableContentBlock" v-bind="$props"/>
</template>

<script>
import Block from './Block.vue';
import DynamicBlock from './DynamicBlock.vue';

import { DynamicBlockModel } from '../models';
import { contentBlockType } from '../constants';

export default {
  name: 'content-block',
  components: {
    DynamicBlock,
    PaginableContentBlock: () => import('./contentBlocks/PaginableContentBlock.vue'),
    ScrollableContentBlock: () => import('./contentBlocks/ScrollableContentBlock.vue')
  },
  extends: Block,
  props: {
    behaviourType: {type: String, default: contentBlockType.DEFAULT},
    children: {type: Array, default: () => ([])}
  },
  computed: {
    myChildren() {
      return this.children.map((_) => new DynamicBlockModel(_));
    },
    isDefaultContentBlock() {
      return this.behaviourType === contentBlockType.DEFAULT;
    },
    isPaginableContentBlock() {
      return this.behaviourType === contentBlockType.PAGINABLE;
    },
    isScrollableContentBlock() {
      return this.behaviourType === contentBlockType.SCROLLABLE;
    },
    selectedLinkId() {
      return this.$store.getters.getSelectedLinkId(this.guid);
    },
    browserItemsOrder() {
      return this.$store.getters.getBrowserItemsOrder(this.guid);
    },
  }
};
</script>
